/**
 * Import constants
 */
import { GET_REJECTED_DATA_PENDING, GET_REJECTED_DATA, GET_REJECTED_DATA_ERROR } from '../actions/constants';

/**
 * Initial state
 */
const initialState = {
	loading: true,
	data: {},
	error: null
};
/**
 * Rejected data reducer
 * @param {*} state
 * @param {*} action
 */
export const rejectedReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_REJECTED_DATA_PENDING:
			return {
				...state,
				loading: true
			};
		case GET_REJECTED_DATA:
			return {
				...state,
				loading: false,
				data: Object.assign({}, state.data, action.payload),
				error: null
			};
		case GET_REJECTED_DATA_ERROR:
			return {
				...state,
				loading: true,
				error: action.payload
			};
		default:
			return state;
	}
};
